import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/deposits';
import widgetsHelper from 'utils/getWidget.helper';
import {apiback} from '../../../../../config';
import BusinessDepositsModel from '../models/business-deposits.m';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            mode: 'step-one',
            modes: [
                {
                    mode: 'step-one',
                    title: 'BUSINESS_DEPOSITS_TERMINAL_WITHOUT_CANCELATION'
                },
                {
                    mode: 'step-two',
                    title: 'BUSINESS_DEPOSITS_TERMINAL'
                },
                {
                    mode: 'step-three',
                    title: 'BUSINESS_DEPOSITS_OVERNIGHT'
                },
                {
                    mode: 'step-four',
                    title: 'BUSINESS_DEPOSITS_REMAIN_PERCENT'
                }
            ],
            where_by: ['path'],
            search_by: ['/business/deposits'],
            widgets: [],
            where_by_2: ['path'],
            search_by_2: ['/business/deposits_term'],
            widgets_2: [],
            showModal: false,
            model: {},
            showCalcModal: false,
            loader: true
        };
        this.toggleMode = this.toggleMode.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.scrollToOvernightDetails = this.scrollToOvernightDetails.bind(this);
        this.widgetsHelper = widgetsHelper;
        return this;
    }

    toggleMode = mode => {
        this.setState({mode: mode});
    };

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
        this.widgetsHelper.getWidgets_2.call(this);
        this.scrollToCalc();
        this.unlisten = this.props.history.listen(() => {
            this.applyModeFromUrl();
        });

        fetch(apiback('BUSINESS_DEPOSITS_REMAIN_PERCENT_CALC'))
            .then(res => res.json())
            .then(json => {
                const model = new BusinessDepositsModel(json.data['deposits']);
                this.setState({model}, () => {
                    this.applyModeFromUrl();
                });
            })
            .catch(err => {
                console.error('BusinessDeposits: failed to load calc data', err);
                this.applyModeFromUrl();
            });
    }

    scrollToCalc = () => {
        const currentURL = window.location.href;

        if (currentURL.includes('stavky_depozyty_MSB')) {
            this.scrollWhenLoaded(() => document.getElementById('anchor_deposits_msb'));
        }
    };

    applyModeFromUrl = () => {
        const modeByPath = {
            deposits_over: 'step-three',
            deposits_percent: 'step-four'
        };

        const modeByAnchor = {
            vidsotok_na_zalyshok: {mode: 'step-four', scrollTarget: '.calculator-new'}
        };

        const currentURL = window.location.href;
        const anchorKey = Object.keys(modeByAnchor).find(k => currentURL.includes(k));

        if (anchorKey) {
            const {mode, scrollTarget} = modeByAnchor[anchorKey];
            this.setState({mode}, () => {
                this.scrollWhenLoaded(() => document.querySelector(scrollTarget));
            });
            return;
        }

        const pathname = window.location.pathname;
        const segments = pathname.split('/').filter(Boolean);
        const lastSegment = segments[segments.length - 1];

        const mode = modeByPath[lastSegment] || 'step-one';

        if (this.state.mode !== mode) {
            this.setState({mode}, () => this.scrollToActiveTab());
        }
    };

    scrollToActiveTab = () => {
        this.scrollWhenLoaded(() => document.querySelector('.nav-bar'));
    };

    scrollWhenLoaded = getTarget => {
        if (this.state.loader) {
            this.pendingScroll = getTarget;
            return;
        }
        const target = getTarget();
        if (target) target.scrollIntoView({behavior: 'smooth', block: 'start'});
    };

    componentDidUpdate() {
        if (this.pendingScroll && !this.state.loader) {
            const getTarget = this.pendingScroll;
            this.pendingScroll = null;
            this.scrollWhenLoaded(getTarget);
        }
    }

    scrollToOvernightDetails = () => {
        const targetElement = document.querySelector('.tab-content');
        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            this.setState({mode: 'step-three'});
        }
    };

    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }

    toggleCalcModal = () => {
        this.setState({showCalcModal: !this.state.showCalcModal});
    };

    componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    }
}
